import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const ClientBadgeContainer = styled.div`
  display: flex;
  height: 24px;
  min-width: 100px;
  border-radius: 4px;
  padding: 2px 12px;
  background-color: ${colors.bg['surface-700']};
  align-items: center;
  justify-content: center;

  & > span {
    font-weight: 600;
    font-size: 11px;
    line-height: 180%;
    color: ${colors.text['white-0']};
  }

  @media (min-width: 766px) {
    max-width: 100px;
    transition: max-width 150ms ease;

    &:hover {
      max-width: 100%;
      span {
        white-space: nowrap;
        max-width: 100%;
      }
    }
  }

  @media (max-width: 765px) {
    padding: 2px 4px;
  }
`;
